import { Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

@Injectable()
export class MensagemService extends MessageService {
  private suprimindoErros = false;

  /** Executa `propagar` com os toasts de erro das telas suprimidos. */
  comErrosLocaisSuprimidos(propagar: () => void): void {
    this.suprimindoErros = true;
    try {
      propagar();
    } finally {
      this.suprimindoErros = false;
    }
  }

  override add(message: ToastMessageOptions): void {
    if (this.deveSuprimir(message)) return;
    super.add(message);
  }

  override addAll(messages: ToastMessageOptions[]): void {
    const restantes = messages.filter(m => !this.deveSuprimir(m));
    if (restantes.length) super.addAll(restantes);
  }

  private deveSuprimir(message: ToastMessageOptions): boolean {
    return this.suprimindoErros && message?.severity === 'error';
  }
}
